module.exports = __webpack_public_path__ + "img/edit1.1919a60e.png";